import { PartialTenantCustomizations } from "src/tenantCustomizations/TenantCustomizations";

export const demo1Customizations: PartialTenantCustomizations = {
	tenantConfig: {
		erp: {
			enabled: true,
		},
	},
} as const;
